export const LAUNDRY_PRODUCT_FOCUS = "Laundry Detergent Sheets";

export const LAUNDRY_INQUIRY_FIELD_NAMES = {
  estimatedOrderQuantity: "Estimated Order Quantity",
  packagingType: "Packaging Type",
  expectedLaunchDate: "Expected Launch Date",
  needs: "What Do You Need",
  productFocus: "Product Focus",
  inquirySummary: "Laundry Sheet Inquiry Details",
};

export const estimatedOrderQuantityOptions = [
  "1,000–2,999 retail units",
  "3,000–4,999 retail units",
  "5,000–9,999 retail units",
  "10,000+ retail units",
  "Not sure yet",
];

export const packagingTypeOptions = [
  "Paper Box",
  "Paper Envelope",
  "Pouch / Bag",
  "Bulk / Refill",
  "Need Recommendation",
  "Other",
];

export const needOptions = [
  "Samples",
  "Quote",
  "Custom Formula",
  "Packaging Support",
];

export const appendLaundrySheetInquiryMetadata = (formData) => {
  formData.set(LAUNDRY_INQUIRY_FIELD_NAMES.productFocus, LAUNDRY_PRODUCT_FOCUS);

  const selectedNeeds = formData
    .getAll(LAUNDRY_INQUIRY_FIELD_NAMES.needs)
    .filter(Boolean);

  if (selectedNeeds.length) {
    formData.set(LAUNDRY_INQUIRY_FIELD_NAMES.needs, selectedNeeds.join(", "));
  }

  const summaryFields = [
    LAUNDRY_INQUIRY_FIELD_NAMES.estimatedOrderQuantity,
    LAUNDRY_INQUIRY_FIELD_NAMES.packagingType,
    LAUNDRY_INQUIRY_FIELD_NAMES.expectedLaunchDate,
    LAUNDRY_INQUIRY_FIELD_NAMES.needs,
  ];

  const summary = summaryFields
    .map((fieldName) => {
      const value = formData.get(fieldName);
      return value ? `${fieldName}: ${value}` : null;
    })
    .filter(Boolean)
    .join("\n");

  if (summary) {
    formData.set(LAUNDRY_INQUIRY_FIELD_NAMES.inquirySummary, summary);
  }

  return formData;
};
